// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".events-footer{background-color:rgba(33,33,33,.9);color:#b7b7b7;font-size:12px;height:44px;position:relative;z-index:10}.events-footer a{color:#a4a4a4;transition:color .3s}.events-footer a:hover{color:#fff}@media(max-width:1023px){.events-footer{flex-direction:column;justify-content:space-around}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
